import { createSlice, current } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';
import defaultSplashPageConfig from './config.json';

let fakeDataCaptivePortal = [
  {
    id: 'c8f9e1d2-a3b4-5678-9012-345678901234',
    name: 'Guest Portal',
    authType: 'CLICK_THROUGH',
    idleTimeout: 60,
    idleTimeoutOption: 'DEFAULT',
    authTimeout: 0,
    authTimeoutOption: 'DISABLE',
    authPerDay: 720,
    authPerDayOption: 'CUSTOM',
    reAuthInterval: 0,
    reAuthIntervalOption: 'DISABLE',
    landingPageOption: 'NO_SPECIFIC',
    landingPageUrl: '',
    macWhiteList: 'mac-group-001',
    externalCaptivePortal: null,
    ldapProfile: null,
    radiusProfile: null,
    splashPageConfig: null,
    splashPageUrl: null,
    userProfile: null,
    walledGarden: false,
    walledGardenList: null,
  },
  {
    id: 'd9g0f2e3-b4c5-6789-0123-456789012345',
    name: 'Staff Portal',
    authType: 'CLICK_THROUGH',
    idleTimeout: 1440,
    idleTimeoutOption: 'CUSTOM',
    authTimeout: 480,
    authTimeoutOption: 'ENABLE',
    authPerDay: 0,
    authPerDayOption: 'UNLIMIT',
    reAuthInterval: 30,
    reAuthIntervalOption: 'ENABLE',
    landingPageOption: 'CUSTOM',
    landingPageUrl: 'https://example.com/welcome',
    macWhiteList: null,
    externalCaptivePortal: null,
    ldapProfile: null,
    radiusProfile: null,
    splashPageConfig: null,
    splashPageUrl: null,
    userProfile: null,
    walledGarden: false,
    walledGardenList: null,
  },
];

const initialState = {
  resource: 'captivePortal',
  data: [],
  splashPageConfig: defaultSplashPageConfig,
};

export const captivePortalSlice = createSlice({
  name: 'captivePortal',
  initialState,
  reducers: {
    initCaptivePortal: (state, _) => {
      if (state.data.length === 0) {
        state.data = [...fakeDataCaptivePortal];
      }
    },
    addCaptivePortal: (state, action) => {
      // console.log('Add captive portal: ', action.payload);
      if (!action?.payload?.id) {
        action.payload['id'] = uuidv4();
      }
      state.data.push(action.payload);
    },
    updateCaptivePortal: (state, action) => {
      // console.log('Update captive portal: ', action.payload);
      // console.log('reducer:', action.type, current(state));
      const index = state.data.findIndex(p => p.id === action.payload.id);
      if (index !== -1) {
        state.data[index] = {
          ...state.data[index],
          ...action.payload,
        };
      }
    },
    deleteCaptivePortal: (state, action) => {
      // console.log('Delete captive portal: ', action.payload);
      const { captivePortalIds } = action.payload;
      state.data = state.data.filter(item => !captivePortalIds.includes(item.id));
    },
    getDefaultSplashPageConfig: (state, _) => {
      // console.log('Get default splash page config', defaultSplashPageConfig);
      // console.log(current(state))
      state.splashPageConfig = defaultSplashPageConfig;
    },
    updateSplashPageConfig: (state, action) => {
      // console.log('Update captive portal: ', action.payload);
      // console.log('reducer:', action.type, current(state));
      const index = state.data.findIndex(p => p.id === action.payload.id);
      if (index !== -1) {
        state.data[index] = {
          ...state.data[index],
          ...action.payload,
        };
      }
    },
  },
});

export const { initCaptivePortal, addCaptivePortal, updateCaptivePortal, deleteCaptivePortal, getDefaultSplashPageConfig, updateSplashPageConfig } = captivePortalSlice.actions;

export default captivePortalSlice.reducer;
